export function RoutePartnersAllowed() {

    return [
        { partner: 'number118', routes: ['/dashboard-live']}
    ];
}


// WEBPACK FOOTER //
// ./src/router/AllowedRoute/RoutePartnersAllowed.js